export default [
    {
        path: 'my-tasks',
        name: 'tasks-my-tasks',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: 'menu_points./tasks/my-tasks',
            translate: (t) => {
                return t('menu_points.my_tasks').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'tasks-my-tasks-list' },
        children: [
            {
                path: '',
                name: 'tasks-my-tasks-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./tasks/my-tasks',
                    translate: (t) => {
                        return t('menu_points.my_tasks').ucFirst();
                    },
                },
                component: () => import('@/views/pages/tasks/tasks/own.vue'),
                props: { own: true },
            },
            {
                path: 'create',
                name: 'tasks-my-task-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./tasks/my-tasks',
                    translate: (t, tc) => t('base.create_new_item', {item: tc('tasks::tasks.task', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/tasks/tasks/item.vue'),
                props: { own: true },
            },
            {
                path: ':id(\\d+)',
                name: 'tasks-my-task-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./tasks/my-tasks',
                    translate: (t, tc) => t('base.edit_item', {item: tc('tasks::tasks.task', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/tasks/tasks/item.vue'),
                props: { own: true },
            },
        ]
    },
    {
        path: 'accessible-tasks',
        name: 'tasks-accessible-tasks',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: 'menu_points./tasks/accessible-tasks',
            translate: (t) => {
                return t('menu_points.accessible_tasks').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'tasks-accessible-tasks-list' },
        children: [
            {
                path: '',
                name: 'tasks-accessible-tasks-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./tasks/accessible-tasks',
                    translate: (t) => {
                        return t('menu_points.accessible_tasks').ucFirst();
                    },
                },
                component: () => import('@/views/pages/tasks/tasks/accessible.vue'),
            },
            {
                path: 'create',
                name: 'tasks-accessible-task-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./tasks/accessible-tasks',
                    translate: (t, tc) => t('base.create_new_item', {item: tc('tasks::tasks.task', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/tasks/tasks/item.vue'),
                props: { accessible: true },
            },
            {
                path: ':id(\\d+)',
                name: 'tasks-accessible-task-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./tasks/accessible-tasks',
                    translate: (t, tc) => t('base.edit_item', {item: tc('tasks::tasks.task', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/tasks/tasks/item.vue'),
                props: { accessible: true },
            },
        ]
    },
];